"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TErc20V4Factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "cashPrior",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "interestAccumulated",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "borrowIndex",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "totalBorrows",
                type: "uint256",
            },
        ],
        name: "AccrueInterest",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Approval",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "borrowAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "accountBorrows",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "totalBorrows",
                type: "uint256",
            },
        ],
        name: "Borrow",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "error",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "info",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "detail",
                type: "uint256",
            },
        ],
        name: "Failure",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "liquidator",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "repayAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "tTokenCollateral",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "seizeTokens",
                type: "uint256",
            },
        ],
        name: "LiquidateBorrow",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "minter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "mintAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "mintTokens",
                type: "uint256",
            },
        ],
        name: "Mint",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "NewAdmin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract InterestRateModel",
                name: "oldInterestRateModel",
                type: "address",
            },
            {
                indexed: false,
                internalType: "contract InterestRateModel",
                name: "newInterestRateModel",
                type: "address",
            },
        ],
        name: "NewMarketInterestRateModel",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldPendingAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newPendingAdmin",
                type: "address",
            },
        ],
        name: "NewPendingAdmin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldReserveFactorMantissa",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newReserveFactorMantissa",
                type: "uint256",
            },
        ],
        name: "NewReserveFactor",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract TectonicCoreInterface",
                name: "oldTectonicCore",
                type: "address",
            },
            {
                indexed: false,
                internalType: "contract TectonicCoreInterface",
                name: "newTectonicCore",
                type: "address",
            },
        ],
        name: "NewTectonicCore",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "redeemer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "redeemAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "redeemTokens",
                type: "uint256",
            },
        ],
        name: "Redeem",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "payer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "repayAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "accountBorrows",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "totalBorrows",
                type: "uint256",
            },
        ],
        name: "RepayBorrow",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "payer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "repayAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "accountBorrows",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "totalBorrows",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "accountTokens",
                type: "uint256",
            },
        ],
        name: "RepayBorrowWithTToken",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "benefactor",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "addAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newTotalReserves",
                type: "uint256",
            },
        ],
        name: "ReservesAdded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "admin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "reduceAmount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newTotalReserves",
                type: "uint256",
            },
        ],
        name: "ReservesReduced",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "from",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "to",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "Transfer",
        type: "event",
    },
    {
        constant: true,
        inputs: [],
        name: "XTONIC_BOOST_TYPE_BORROW",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "XTONIC_BOOST_TYPE_SUPPLY",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "_acceptAdmin",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "addAmount",
                type: "uint256",
            },
        ],
        name: "_addReserves",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "tonicLikeDelegatee",
                type: "address",
            },
        ],
        name: "_delegateTonicLikeTo",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "reduceAmount",
                type: "uint256",
            },
        ],
        name: "_reduceReserves",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "contract InterestRateModel",
                name: "newInterestRateModel",
                type: "address",
            },
        ],
        name: "_setInterestRateModel",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address payable",
                name: "newPendingAdmin",
                type: "address",
            },
        ],
        name: "_setPendingAdmin",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "newReserveFactorMantissa",
                type: "uint256",
            },
        ],
        name: "_setReserveFactor",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "contract TectonicCoreInterface",
                name: "newTectonicCore",
                type: "address",
            },
        ],
        name: "_setTectonicCore",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "accrualBlockNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "accrueInterest",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address payable",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
        ],
        name: "allowance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "spender",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "approve",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "owner",
                type: "address",
            },
        ],
        name: "balanceOfUnderlying",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "borrowAmount",
                type: "uint256",
            },
        ],
        name: "borrow",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "borrowBalanceCurrent",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "borrowBalanceStored",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "borrowIndex",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address payable",
                name: "borrower",
                type: "address",
            },
            {
                internalType: "address payable",
                name: "receiver",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "borrowAmount",
                type: "uint256",
            },
        ],
        name: "borrowOnBehalf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "borrowRatePerBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "decimals",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "deferLiquidityCheckAdapterAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "exchangeRateCurrent",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "exchangeRateStored",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "address",
                name: "account",
                type: "address",
            },
        ],
        name: "getAccountSnapshot",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "getCash",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "underlying_",
                type: "address",
            },
            {
                internalType: "contract TectonicCoreInterface",
                name: "tcore_",
                type: "address",
            },
            {
                internalType: "contract InterestRateModel",
                name: "interestRateModel_",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "initialExchangeRateMantissa_",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "name_",
                type: "string",
            },
            {
                internalType: "string",
                name: "symbol_",
                type: "string",
            },
            {
                internalType: "uint8",
                name: "decimals_",
                type: "uint8",
            },
        ],
        name: "initialize",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "contract TectonicCoreInterface",
                name: "tcore_",
                type: "address",
            },
            {
                internalType: "contract InterestRateModel",
                name: "interestRateModel_",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "initialExchangeRateMantissa_",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "name_",
                type: "string",
            },
            {
                internalType: "string",
                name: "symbol_",
                type: "string",
            },
            {
                internalType: "uint8",
                name: "decimals_",
                type: "uint8",
            },
        ],
        name: "initialize",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "interestRateModel",
        outputs: [
            {
                internalType: "contract InterestRateModel",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "isTToken",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "repayAmount",
                type: "uint256",
            },
            {
                internalType: "contract TTokenInterface",
                name: "tTokenCollateral",
                type: "address",
            },
        ],
        name: "liquidateBorrow",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "mintAmount",
                type: "uint256",
            },
        ],
        name: "mint",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "pendingAdmin",
        outputs: [
            {
                internalType: "address payable",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "protocolSeizeShareMantissa",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "redeemTokens",
                type: "uint256",
            },
        ],
        name: "redeem",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "redeemAmount",
                type: "uint256",
            },
        ],
        name: "redeemUnderlying",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "repayAmount",
                type: "uint256",
            },
        ],
        name: "repayBorrow",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "repayAmount",
                type: "uint256",
            },
        ],
        name: "repayBorrowBehalf",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "repayAmount",
                type: "uint256",
            },
        ],
        name: "repayBorrowBehalfWithTToken",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "repayAmount",
                type: "uint256",
            },
        ],
        name: "repayBorrowWithTToken",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "reserveFactorMantissa",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "liquidator",
                type: "address",
            },
            {
                internalType: "address",
                name: "borrower",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "seizeTokens",
                type: "uint256",
            },
        ],
        name: "seize",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_deferLiquidityCheckAdapterAddress",
                type: "address",
            },
        ],
        name: "setDeferLiquidityCheckAdapter",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "_tectonicBoostAddress",
                type: "address",
            },
        ],
        name: "setTectonicBoostAddress",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "supplyRatePerBlock",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "contract EIP20NonStandardInterface",
                name: "token",
                type: "address",
            },
        ],
        name: "sweepToken",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "symbol",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tERC20Version",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        payable: false,
        stateMutability: "pure",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tectonicBoostAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tectonicCore",
        outputs: [
            {
                internalType: "contract TectonicCoreInterface",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalBorrows",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "totalBorrowsCurrent",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalReserves",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "totalSupply",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "dst",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transfer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "src",
                type: "address",
            },
            {
                internalType: "address",
                name: "dst",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "amount",
                type: "uint256",
            },
        ],
        name: "transferFrom",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "underlying",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
class TErc20V4Factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.TErc20V4Factory = TErc20V4Factory;
TErc20V4Factory.bytecode = _bytecode;
TErc20V4Factory.abi = _abi;
//# sourceMappingURL=TErc20V4Factory.js.map